"use client"

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "~/components/ui/alert-dialog"
import { AsyncButton } from "~/components/ui/async-button"
import { useLogout } from "../hooks/use-logout"

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const LogoutConfirmDialog = ({ open, onOpenChange }: Props) => {
  const performLogout = useLogout()

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent onDismiss={() => onOpenChange(false)}>
        <AlertDialogHeader>
          <AlertDialogTitle>Выйти из аккаунта?</AlertDialogTitle>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Отмена</AlertDialogCancel>
          <AsyncButton fn={performLogout} onSuccess={() => onOpenChange(false)}>
            Выйти
          </AsyncButton>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
